import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInfoCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 28 29"
    {...props}
  >
    <path
      fill="#6FA9FF"
      d="M14 .938c7.438 0 13.563 6.125 13.563 13.562 0 7.492-6.125 13.563-13.563 13.563C6.508 28.063.438 21.993.438 14.5.438 7.063 6.508.938 14 .938m0 24.5c6.016 0 10.938-4.868 10.938-10.938 0-6.016-4.922-10.937-10.938-10.937-6.07 0-10.937 4.921-10.937 10.937A10.9 10.9 0 0 0 14 25.438m0-18.485a2.31 2.31 0 0 1 2.297 2.297A2.276 2.276 0 0 1 14 11.547c-1.312 0-2.297-.985-2.297-2.297 0-1.258.985-2.297 2.297-2.297m3.063 13.89a.665.665 0 0 1-.657.657h-4.812a.63.63 0 0 1-.656-.656V19.53c0-.328.273-.656.656-.656h.656v-3.5h-.656a.63.63 0 0 1-.656-.656v-1.313c0-.328.273-.656.656-.656h3.5c.328 0 .656.328.656.656v5.469h.656c.328 0 .657.328.657.656z"
    />
  </svg>
);
export default SvgInfoCircle;
